/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { Card, Col, Container, Row, Table } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '18px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

function SlotLocation() {
  const [item, setItem] = useState([])
  const { state } = useLocation()

  useEffect(() => {
    const { slotLocations, batch } = state
    const slotLocation = slotLocations.find((value) => value.batch === batch)
    setItem(slotLocation)
  }, [])

  return (
    <>
      <Container fluid className="px-4 mb-5">
        <Row className="mb-4">
          <Col md={12}>
            <div className="d-flex flex-column justify-content-start">
              <h4 style={headerTitleStyle}>Slot Location</h4>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb mb-1" style={{ fontSize: '12px' }}>
                  <li className="breadcrumb-item sj-item">
                    <Link
                      to={'/outbound/transfer'}
                      className="text-decoration-none"
                    >
                      <span className="text-muted fw-bold">TR</span>
                    </Link>
                  </li>
                  <li className="breadcrumb-item sj-item">
                    <Link
                      to={`/outbound/transfer/detail/${state.trId}`}
                      className="text-decoration-none"
                    >
                      <span className="text-muted fw-bold">{state.trCode}</span>
                    </Link>
                  </li>
                  <li
                    className="breadcrumb-item sj-item active"
                    aria-current="page"
                  >
                    <span className="fw-bold" style={{ color: '#bdbdbd' }}>
                      SLOT LOCATION
                    </span>
                  </li>
                </ol>
              </nav>
            </div>
          </Col>
        </Row>

        <Card style={cardFilterStyle}>
          <div className="d-flex flex-row justify-content-between mb-3">
            <h5 className="fw-bold text-uppercase" style={{ color: '#828282' }}>
              slot location
            </h5>
            <h6
              className="fw-bold text-uppercase mt-1 me-4"
              style={{ color: '#828282' }}
            >
              <span style={{ color: '#219653' }}>{item?.available_qty}</span>
              <span> / </span>
              <span className="fw-bold">{item?.need_qty} Pack</span>
            </h6>
          </div>
          <Row>
            <Col md={12}>
              <Table
                hover
                responsive
                className="shadow-sm bg-white"
                style={{
                  fontSize: '13px',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  marginBottom: 0
                }}
              >
                <thead style={{ backgroundColor: '#f8f9fa' }}>
                  <tr>
                    <th className="p-2 align-middle" style={tableHeaderStyle}>
                      No
                    </th>
                    <th className="p-2 align-middle" style={tableHeaderStyle}>
                      Item
                    </th>
                    <th
                      className="p-2 align-middle text-center"
                      style={tableHeaderStyle}
                    >
                      Item Alias
                    </th>
                    <th
                      className="p-2 align-middle text-center"
                      style={{ ...tableHeaderStyle, width: '15%' }}
                    >
                      Item Code
                    </th>
                    <th
                      className="p-2 align-middle text-center"
                      style={tableHeaderStyle}
                    >
                      Batch
                    </th>
                    <th
                      className="p-2 align-middle text-center"
                      style={tableHeaderStyle}
                    >
                      Total Pack
                    </th>
                    <th
                      className="p-2 align-middle text-end"
                      style={tableHeaderStyle}
                    >
                      Slot
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {item?.items?.length === 0 && (
                    <>
                      <tr>
                        <td colSpan={7} className="fw-bold text-center p-3">
                          No Data
                        </td>
                      </tr>{' '}
                    </>
                  )}
                  {item?.items?.length > 0 && (
                    <>
                      {item?.items.map((data, i) => (
                        <tr key={i}>
                          <td className="p-2 align-middle">{i + 1}</td>
                          <td className="p-2 align-middle">
                            {data?.item_name}
                          </td>
                          <td className="p-2 align-middle text-center">
                            {data?.item_alias ?? '-'}
                          </td>
                          <td className="p-2 align-middle text-center">
                            {data?.item_code}
                          </td>
                          <td className="p-2 align-middle text-center">
                            {data?.batch ?? '-'}
                          </td>
                          <td className="p-2 align-middle text-center">
                            {data?.total_pack} {data?.uom_pack}
                          </td>
                          <td className="p-2 align-middle text-end">
                            {data?.location}
                          </td>
                        </tr>
                      ))}
                    </>
                  )}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Card>
      </Container>
    </>
  )
}

export default SlotLocation
